export const featureAvailabilityConfig = {
  home: { label: 'Home', mode: 'enabled', actions: ['read'] },
  assets: { label: 'Assets', mode: 'enabled', actions: ['read'] },
  iod: {
    label: 'Inspection Object Database',
    mode: 'enabled',
    actions: ['read', 'export']
  },
  anomalies: {
    label: 'Anomaly Suite',
    mode: 'enabled',
    actions: ['read', 'export']
  },
  reports: {
    label: 'Report Browser',
    mode: 'enabled',
    actions: ['read', 'export']
  },
  inspection: {
    label: 'Inspection Suite',
    mode: 'preview',
    message:
      'Explore maintenance planning using your registered inspection objects. Drafts are temporary and are not saved to your account. Export JSON before leaving. Operational scheduling, import and inspection completion are not available yet.',
    actions: ['read', 'draft', 'export'],
    previewActions: ['read', 'draft', 'export']
  },
  history: {
    label: 'Lifecycle History',
    mode: 'preview',
    message:
      'Preview the chronology of existing anomaly and report records. A complete audit of inspection completion and anomaly status changes is not connected yet.',
    actions: ['read', 'export'],
    previewActions: ['read', 'export']
  },
  taxonomy: {
    label: 'Anomaly taxonomy',
    mode: 'hidden',
    message: 'This feature is not available in this release.',
    actions: ['read']
  }
}
